import api from './api';

/**
 * @returns {Promise<{
 *  activity_logs_id: string
 *  user_name: string | null
 *  changed_field:string | null
 *  previous_value: string | null
 *  current_value: string | null
 *  created_at: string
 *  updated_at: string
 * }[]}
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#api-Assets-GetAudios
 */
export default async function getActivityLogs(type, id) {
    const { data } = await api.get(`activity_logs/${type}/${id}`);
    return data;
}